// extracted by mini-css-extract-plugin
export default {"product__wrapper":"Product_product__wrapper__ahCFi","product__img":"Product_product__img__yPVfa","product__content":"Product_product__content__UCd2g"};